import { render, staticRenderFns } from "./ImportRecipient.vue?vue&type=template&id=cb9259b2&scoped=true&"
import script from "./ImportRecipient.vue?vue&type=script&lang=js&"
export * from "./ImportRecipient.vue?vue&type=script&lang=js&"
import style0 from "./ImportRecipient.vue?vue&type=style&index=0&id=cb9259b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9259b2",
  null
  
)

component.options.__file = "ImportRecipient.vue"
export default component.exports